import React from 'react';

import {
  Typography,
  Form,
  Row,
  Col,
  TimePicker,
  Select,
  Radio,
  Divider,
} from 'antd';

import WrapperSelect from 'common/components/select/WrapperSelect';

import DownloadFolderMonthSetting from './DownloadFolderMonthSetting';
import DownloadFolderWeekSetting from './DownloadFolderWeekSetting';

import { TIME_ZONES } from 'static/TimeZones';
import { SCHEDULE_FORM_LAYOUT } from '../constants';

const { Paragraph } = Typography;
const { Option } = Select;

const DownloadFolderScheduleForm = () => {
  const form = Form.useFormInstance();
  const interval = Form.useWatch('interval', form);

  return (
    <div className='download-folder__schedule-settings'>
      <Paragraph style={{ textAlign: 'center' }}>
        Use the information below to setup an automation schedule
      </Paragraph>
      <Row wrap={false}>
        <Col span={10}>
          <Form.Item
            {...SCHEDULE_FORM_LAYOUT}
            name='runAt'
            label='Run at'
            rules={[
              {
                required: true,
                message: 'This field is required',
              },
            ]}
          >
            <TimePicker
              format={'HH:mm:ss'}
              getPopupContainer={(trigger) => trigger.parentElement}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name='timezone'
            label=''
            rules={[
              {
                required: true,
                message: 'This field is required',
              },
            ]}
          >
            <WrapperSelect
              showSearch
              placeholder='Please choose timezone'
              optionFilterProp='children'
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {TIME_ZONES.map((zone) => (
                <Option key={zone.text} value={zone.utc[0]}>
                  {zone.text}
                </Option>
              ))}
            </WrapperSelect>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item name='interval' label='Interval' {...SCHEDULE_FORM_LAYOUT}>
        <Radio.Group style={{ width: '100%' }}>
          <Row>
            <Col span={8}>
              <Radio value={'Daily'}>Daily</Radio>
            </Col>
            <Col span={8}>
              <Radio value={'Weekly'}>Weekly</Radio>
            </Col>
            <Col span={8}>
              <Radio value={'Monthly'}>Monthly</Radio>
            </Col>
          </Row>
        </Radio.Group>
      </Form.Item>

      <Divider
        style={{ margin: '0px auto 16px', minWidth: '60%', width: '60%' }}
      />
      {interval === 'Weekly' ? <DownloadFolderWeekSetting /> : null}
      {interval === 'Monthly' ? <DownloadFolderMonthSetting /> : null}
    </div>
  );
};

export default DownloadFolderScheduleForm;
